var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"py-2 px-0",attrs:{"items":_vm.aDataItems,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"titlesdark--text",attrs:{"href":item.href}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }